import { withStyles } from '@material-ui/core/styles';
import { variables } from 'components/Theme';

export default withStyles((theme) => ({
  tabsRoot: {
    borderBottom: '1px solid #e8e8e8',
    background: '#fff',
  },
  tabsIndicator: {
    backgroundColor: '#192542',
    height: 3,
  },
  tabRoot: {
    color: '#818B9D',
    fontSize: 14,
    textTransform: 'uppercase',
    minWidth: 72,
    fontWeight: 500,
    '&:hover': {
      color: '#818B9D',
      opacity: 1,
    },
    '&$tabSelected': {
      color: '#192542',
      fontWeight: 600,
    },
    '&:focus': {
      color: '#192542',
    },
  },
  scrollButton: {
    flex: '0 0 32px',
  },
  tabSelected: {},
  image: {
    width: '100%',
    height: 'auto',
    maxWidth: '200px',
    display: 'block',
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    boxShadow: theme.shadows[1],
    margin: `0 auto ${theme.spacing(4)}px auto`,
  },
  title: {
    color: variables.palette.primary.main,
    fontSize: theme.typography.pxToRem(18),
    lineHeight: 1.2,
    fontWeight: 500,
  },
  date: {
    color: variables.palette.primary.dark,
    fontSize: theme.typography.pxToRem(11),
    lineHeight: 1,
    textTransform: 'uppercase',
  },
  column: { textAlign: 'center' },
  author: {
    color: variables.palette.grey[400],
    fontSize: theme.typography.pxToRem(14),
    lineHeight: 1.2,
    fontWeight: 400,
  },
  category: {
    fontSize: theme.typography.pxToRem(14),
    color: variables.palette.primary.main,
  },
  price: {
    fontSize: theme.typography.pxToRem(24),
    color: variables.palette.secondary.main,
    fontWeight: 400,
  },
  comission: {
    fontSize: theme.typography.pxToRem(32),
    color: variables.palette.secondary.main,
    fontWeight: 400,
  },
  achievements: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
  },
  achievementsTitle: {
    color: variables.palette.primary.main,
    padding: `${theme.spacing(4)}px 0`,
    fontWeight: 500,
    display: 'block',
  },
  achievement: {
    display: 'block',
    width: 'calc(100% / 4 - 8px)',
    maxWidth: 80,
    margin: `0 ${theme.spacing(2)}px ${theme.spacing(2)}px 0 `,
    '& > img': {
      width: '100%',
      height: 'auto',
    },
  },
  card: {
    borderRadius: theme.shape.borderRadius,
    boxShadow: variables.shadows[1],
    width: '100%',
    background: 'white',
  },
  cardTitle: {
    padding: `${theme.spacing(2) * 3}px`,
    lineHeight: 1,
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'uppercase',
    color: variables.palette.primary.main,
    '&.modalHead': {
      boxShadow: 'rgba(0, 4, 17, 0.07) 0px 1px 0px 0px, rgba(0, 4, 17, 0.15) 0px 0px 24px 0px',
      borderBottom: `1px solid ${variables.palette.grey[100]}`,
    },
  },
  cardContent: {
    padding: `0 ${theme.spacing(2) * 3}px ${theme.spacing(2) * 3}px ${theme.spacing(2) * 3}px`,
    width: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
    maxHeight: '600px',
  },
  tabContent: {
    padding: theme.spacing(2) * 3,
    overflowX: 'hidden',
    overflowY: 'auto',
    maxHeight: '600px',
    minHeight: '350px',
    lineHeight: 1.5,
  },
  target: {
    marginBottom: theme.spacing(2),
    fontSize: theme.typography.pxToRem(14),
    '& > strong': {
      display: 'block',
      color: variables.palette.primary.main,
      marginBottom: theme.spacing(2) / 4,
    },
    '& > span': {
      color: variables.palette.primary.light,
      display: 'block',
    },
  },
  starScore: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 'inherit',
    lineHeight: 1,
    '&.big': {
      fontSize: 32,
    },
    '&.center': {
      justifyContent: 'center',
    },
  },
  star: {
    color: '#FABB0A',
    fontSize: 'inherit',
    marginRight: theme.spacing(2) / 2,
  },
  evalTitle: {
    display: 'flex',
    alignItems: 'flex-end',
    color: variables.palette.primary.main,
    fontSize: 14,
    '& > $starScore': {
      marginRight: theme.spacing(2),
    },
  },
  evalItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(4),
  },
  evalText: {
    '& > span': {
      color: variables.palette.primary.main,
      display: 'block',
      marginTop: theme.spacing(2) / 2,
    },
    '& > small': {
      color: variables.palette.primary.light,
      marginTop: theme.spacing(2) / 2,
    },
  },
  questionTitle: {
    color: variables.palette.primary.main,
  },
  questionItem: {
    padding: theme.spacing(4),
    backgroundColor: '#F5F5F5',
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(2),
  },
  questionText: {
    color: variables.palette.primary.main,
    lineHeight: 1.3,
    '& > span': {
      color: variables.palette.primary.light,
      marginTop: theme.spacing(2),
      display: 'block',
    },
  },
  questionForm: {
    display: 'flex',
    justifyContent: 'space-between',
    '& > .questionInput': {
      marginTop: theme.spacing(2) / 2,
      marginRight: theme.spacing(2),
    },
    '& > .questionSubmit': {
      marginTop: theme.spacing(2) / 2,
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  moreButton: {},
  modalEvaluation: {
    position: 'absolute',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    borderRadius: theme.shape.borderRadius,
  },
  modalContent: {
    width: '50vw',
    height: 'auto',
    maxHeight: '80vh',
    maxWidth: 1000,
    overflowX: 'hidden',
    overflowY: 'auto',
    padding: theme.spacing(2) * 3,
    [theme.breakpoints.down('sm')]: {
      width: '95vw',
      maxHeight: '80vh',
    },
  },
  modalClose: {
    position: 'absolute',
    top: 20,
    right: 20,
  },
  formItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  buttonGroup: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  contactInfo: {
    lineHeight: 1.3,
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
  },
}));
